import httpClient from "../../../shared/api/httpClient";

// Antecedências dos lembretes de plantão por e-mail, em horas. Sem nenhuma, desligado.
export const shiftRemindersApi = {
  get: () => httpClient.get("/api/v1/shift-reminders").then((r) => r.data.dados),
  update: (leadHours) =>
    httpClient.put("/api/v1/shift-reminders", { lead_hours: leadHours }).then((r) => r.data.dados),
};
